var productSample = {
  $container: '#modal-sample',
  singleOptionSelector: '.single-option-selector-product-sample',
  productSingleObject: null,
  originalSelectorId: '#ProductSelect-product-sample',
  product: null,
  $discountInput: $('.dsc_btn.sample'),
  openModal: function() {
    $("body").addClass('loading showOverly');
    $('.cky-btn-revisit-wrapper').addClass('popupopen');
    back2TopLogic();
    $.get( $(this).data('url')+'?view=product_sample&type='+$(this).data('referer'), function( data ) {
      data = data.split('<!doctype html>');
      data = data[0];
      $( "#modal-sample-body" ).html( data );
      $( "#modal-sample-body .swatch.clearfix.option1 .product-swatches" ).find('.swatch-element').each(function(index) {
        let labelImgElement = $(this).find("label.swatchLbl img");
        let labelVal = $(this).find("label.swatchLbl").text().replaceAll('"','');
        $(this).find("label.swatchLbl").empty().append(labelImgElement).append(labelVal);
      });
      productSample.modalComplete();
    });
  },
  generalActions: function() {
    $(document).on('click','.open-modal-btn.customizeBtn', productSample.openModal);
    $(document).on('click', '.link-modal-sample', productSample.openModal);
    $(document).on('click','.link-modal-sample-associated', function() {
      $(this).closest('.grid-view-item').find('.link-modal-sample').trigger('click');
    });

    $(document).on('click','#modal-sample button.close', function() {
      $( productSample.$container).removeClass( 'show' );
      $( productSample.$container).addClass('tw-hidden');
      $('html').first().removeClass('tw-overflow-y-hidden');
      $('.cky-btn-revisit-wrapper').removeClass('popupopen');
      $("body").removeClass("loading showOverly");
          back2TopLogic();
    });
  },
  modalStatus: function() {
    if($(this.$container).hasClass('show')) {
      $('.drift-frame-controller').hide();
    } else{
      $('.drift-frame-controller').show();
    } 
  },
  init: function(){
    this.generalActions();
    $(document).on('click',"#modal-sample",function(e){
      if($(e.target).hasClass('content-sample') || $(e.target).parents('.content-sample').length > 0 ){
        ;
      }else{
        $('.cky-btn-revisit-wrapper').removeClass('popupopen');
        $( productSample.$container).removeClass( 'show' );
        $( productSample.$container).addClass('tw-hidden');
        $('html').first().removeClass('tw-overflow-y-hidden');
        $("body").removeClass("loading showOverly");
            back2TopLogic();
      }
    });
  },
  colorSwatchMobileScroll: function() {
    //Color Swatch mobile scroll
    let lastColorSwatchScrollLeft = 0;
      const elementWidth = $(this).outerWidth();
      const scrollLeft = $(this).scrollLeft();
      const scrollWidth = $(this).get(0).scrollWidth;
      if ((scrollWidth - scrollLeft) === elementWidth) {
        $('#modal-sample .product-swatches .tw-mobile-gradient.right').addClass('tw-hidden');
      } else {
        $('#modal-sample .product-swatches .tw-mobile-gradient.right').removeClass('tw-hidden');
      }

      if (scrollLeft > lastColorSwatchScrollLeft) {
        $('#modal-sample .product-swatches .tw-mobile-gradient.left').addClass('scrolled');
      }
      
      lastColorSwatchScrollLeft = scrollLeft;
      if (lastColorSwatchScrollLeft == 0){
        $('#modal-sample .product-swatches .tw-mobile-gradient.left').removeClass('scrolled');
      }
  },
  modalComplete: function(){
    var productJsonElement = document.getElementById('ProductJson-product-sample');
    if(productJsonElement){
    this.productSingleObject = JSON.parse(productJsonElement.innerHTML);
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    this.product = this.productSingleObject;
    Shopify.linkOptionSelectorsSample(this.product);
    // * Update the modal selection with the PDP if it exist
    productSample.updateOptionsSelected();

    let isModalSampleByPass = 0;
    if($('#ProductSelect-product-sample').length) {
      switch ($('#ProductSelect-product-sample').data('template')) {
        case 'tile':
          isModalSampleByPass = $('#ProductSelect-product-sample option').length === 1 ? 1 : 0;
        break;
        case 'grid':
          isModalSampleByPass = $('#SingleOptionSelector-0 option','#modal-sample').length === 1 ? 1 : 0;
        break;
        default:
          isModalSampleByPass = $('#ProductSelect-product-sample option').length === 1 ? 1 : 0;
        break;
      }
    }
    // * If we have only one variant sample from PDP (not Collection)
    // * It is added to cart (checkByPass)
    if (isModalSampleByPass && $('#sample-full-details').length == 0) {
      $('#add-to-cart-sample').click();
    } else {
      $('.cky-btn-revisit-wrapper').removeClass('popupopen');
      $("body").removeClass('loading');
      back2TopLogic();
      //JQ( productSample.$container).modal( 'show' );
      $( productSample.$container).removeClass('tw-hidden');
      $('html').first().addClass('tw-overflow-y-hidden');
      setTimeout(() => {
        $( productSample.$container).addClass( 'show' ); 
        $('.tw-kanopi-modal-content').addClass('tw-translate-y-[0px]'); 
        }, 150);
    }
  }
  },
  /**
   * In PDP - Check the value of PDP to pre-select in modal 
   * if exist the conbination
   */
  updateOptionsSelected: function(){
    if($('.pdp-container').length && $('#ProductSelect-product-sample').length) {
      const sample_template = $('#ProductSelect-product-sample').data('template');
      switch (sample_template) {
        case 'tile': {
          const selectPdpEdge = $('#SingleOptionSelector-0','.pdp-container').val();
          const dropdownEdge = $('#SingleOptionSelector-0','#modal-sample');
          dropdownEdge.find('option').each(function() {
            const optionValue = $(this).val();
            if(optionValue == selectPdpEdge) {
              dropdownEdge.val(selectPdpEdge);
              dropdownEdge.trigger('change');
            }
          });

          const selectPdpColor = $('#SingleOptionSelector-2','.pdp-container').val();
          const dropdownColor = $('.swatch.clearfix.option3 .swatch-element:not(.notavailable)','#modal-sample');
          dropdownColor.each(function() {
            const $option = $(this);
            const optionValue = $option.data('value');
            if(optionValue == selectPdpColor) {
              $(this).find('.swatchLbl').trigger('click');
              // For mobile move the scroll 
              if($('.swatch.clearfix.option3','#modal-sample').css('overflow-x') == 'scroll' ){
                setTimeout(() => {
                  let moveLeft = 0;
                  if($('.current-color','#modal-sample').offset().left > 228){
                    moveLeft = $('.current-color','#modal-sample').offset().left * 2;
                  }
                  $('.swatch.clearfix.option3','#modal-sample').scrollLeft( moveLeft );
                }, 500);
              }
            }
          });
          $('#modal-sample .product-swatches .color-swatch-list').on('scroll', productSample.colorSwatchMobileScroll);
          
        }
        break;
        case 'grid': { 
          const selectPdpColor = $('.color-selected-text:first','.pdp-container').text().trim();
          const dropdownColor = $('.swatch.clearfix.option3 li:not(.notavailable)','#modal-sample');
          dropdownColor.each(function() {
            const $option = $(this);
            const optionValue = $option.data('value');
            if(optionValue == selectPdpColor) {
              $option.trigger('click');
              // For mobile move the scroll 
              if($('.swatch.clearfix.option3','#modal-sample').css('overflow-x') == 'scroll' ){
                setTimeout(() => {
                  let moveLeft = 0;
                  if($('.current-color','#modal-sample').offset().left > 228){
                    moveLeft = $('.current-color','#modal-sample').offset().left * 2;
                  }
                  $('.swatch.clearfix.option3','#modal-sample').scrollLeft( moveLeft );
                }, 500);
              }
            }
          });
          $('#modal-sample .product-swatches .color-swatch-list').on('scroll', productSample.colorSwatchMobileScroll);
        }
        break;
        case 'decorative': {
          const selectPdpEdge = $('#SingleOptionSelector-0','.pdp-container').val();
          const dropdownEdge = $('#SingleOptionSelector-0','#modal-sample');
          dropdownEdge.find('option').each(function() {
            const optionValue = $(this).val();
            if(optionValue == selectPdpEdge) {
              dropdownEdge.val(selectPdpEdge);
              dropdownEdge.trigger('change');
            }
          });

          const selectPdpColor = $('#SingleOptionSelector-2','.pdp-container').val();
          const dropdownColor = $('.swatch.clearfix.swatch-color .swatch-element:not(.notavailable)','#modal-sample');
          dropdownColor.each(function() {
            const $option = $(this);
            const optionValue = $option.data('value');
            if(optionValue == selectPdpColor) {
              $(this).find('.swatchLbl').trigger('click');
              // For mobile move the scroll 
              if($('.swatch.clearfix.option2','#modal-sample').css('overflow-x') == 'scroll' ){
                setTimeout(() => {
                  let moveLeft = 0;
                  if($('.current-color','#modal-sample').offset().left > 228){
                    moveLeft = $('.current-color','#modal-sample').offset().left * 2;
                  }
                  $('.swatch.clearfix.option3','#modal-sample').scrollLeft( moveLeft );
                }, 500);
              }
            }
          });
          $('#modal-sample .product-swatches .color-swatch-list').on('scroll', productSample.colorSwatchMobileScroll);
          
        }
        break;
        default:
          
        break;
      }
    }
  },
  /*** Get the currently selected options from add-to-cart form. Works with all
   * form input elements.
   * @return {array} options - Values of currently selected variants */
  _getCurrentOptions: function () {
    var that = this;
    var currentOptions = _.map($(this.singleOptionSelector, this.$container), function (element) {
      var $element = $(element);
      const option =  $element.data('option');
      var type = $element.attr('type');
      var currentOption = {};
      if (type === 'radio' || type === 'checkbox') {
        if ($element[0].checked) {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        } else {
          return false;
        }
      } else {
        currentOption.value = $element.val();
        currentOption.index = $element.data('index');
        var slvaraint = currentOption.value.replace(/'/g, "\\'");
        const endsWithNumber = (str) => /\d$/.test(str); // Validate if the option value ends with a number.
        let optionValue = typeof option === 'string' && option.toLowerCase().includes('edge') && endsWithNumber(slvaraint) ? `${slvaraint}"` : `${slvaraint}`;
        $("." + currentOption.index, that.$container).find(".swatchInput[value='" + slvaraint + "']").prop("checked", true);
        $("." + currentOption.index, that.$container).find(".slVariant").text(optionValue);

        return currentOption;
      }
    });

    // remove any unchecked input values if using radio buttons or checkboxes
    currentOptions = _.compact(currentOptions);

    return currentOptions;
  },
  /*** Find variant based on selected values.
   * @param  {array} selectedValues - Values of variant inputs
   * @return {object || undefined} found - Variant object from product.variants*/
  _getVariantFromOptions: function () {
    var selectedValues = this._getCurrentOptions();
    var variants = this.product.variants;
    var found = _.find(variants, function (variant) {
      return selectedValues.every(function (values) {
        return _.isEqual(variant[values.index], values.value);
      });
    });
    if (found) {
      found = Object.assign(found, { productDescription: this.product.description });
    }

    return found;
  },
  /*** Event handler for when a variant input changes. */
  _onSelectChange: function () {
    // Update shipping times based on the variant selected
    var variant = this._getVariantFromOptions();
    if(variant){
      this.checkShippingTime(variant);
      this._updateMasterSelect(variant);
      this.updateImage(variant);
      this.updatePrice(variant);
      this.displayCustomIncludes(variant.id);
    }
  },
  checkShippingTime: function(variant) {
    $('.shipping-time', this.$container).hide();
    $('#shipping_time_' + variant.id).show();
  },
  updateImage: function(variant){
    $('#image-sample-modal').attr('src',variant?.featured_media?.preview_image?.src);
  },
  updatePrice: function(variant){
    $('#sample__price').html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
  },
  displayCustomIncludes: function(variant_id){
    let $customSamplesIncludes = $('#modal-sample .custom-samples-includes');
    if ($customSamplesIncludes.length > 0){
      $customSamplesIncludes.addClass('tw-hidden');
      $('.custom-samples-includes-' + variant_id).removeClass('tw-hidden');
    }
  },
  /**
   * Add the cart for sample products
   * 
   * @param {string} pdp_url, from sample product we have the pdp url from meta
   * @param {string} sample_label, for Grid it includes a text with all items 
   * @param {string} variant_id, for samples that only has one variant.
   */
  addToCartTile: function(pdp_url, sample_label, variant_id = false){
    // if (typeof stackadaptService === "function") {
    //   stackadaptService();
    // }
    //JQ( this.$container).modal( 'hide' );
    $('.tw-kanopi-modal-content').removeClass('tw-translate-y-[0px]');
      if($( this.$container).hasClass('show')){
        $( this.$container).removeClass( 'show' );
        } 
    setTimeout(() => {
      $(this.$container).addClass('tw-hidden');
      $('html').first().removeClass('tw-overflow-y-hidden');
      }, 150);
    // Add all the products to the cart
    $("body").addClass("loading");
    const variantInfo = $('#ProductSelect-product-sample').val();
    const variantId = typeof variantInfo === 'undefined' ? variant_id : variantInfo;
    const qty = 1;
    const props = {
      '_sample': 1,
      '_sample_url': pdp_url,
      '_sample_variant_title': sample_label
    };
    const discount = this.getDiscount(variantId, this.$discountInput );
    if(discount !== false && localStorage.getItem('applyDiscount') == "true") props['_discount'] = discount;
    let item_count = CartJS.cart.item_count;
    CartJS.addItem(variantId, qty, props,{
      "success": function(data, textStatus, jqXHR){
        let addtoInterval = setInterval(() => {
          if(CartJS.cart.item_count > item_count){
            clearInterval(addtoInterval);
            $("body").removeClass("loading showOverly");
            $(".block-cart").addClass("active");
            showOverly(true);
          }
        }, 500);
        $('.Check_cart_flyout').show();
        if ($('.compatible-grid-sample-block').length > 0){
          $('.compatible-grid-sample-block .grid-sample-before-add').toggleClass('tw-hidden');
          $('.compatible-grid-sample-block .grid-sample-after-add').toggleClass('tw-hidden');
        }
      },
      "error": function(jqXHR, textStatus, errorThrown){
        var errormsg = JSON.parse(jqXHR.responseText).description;
        $("body").removeClass("loading");
        $(".error-message").text(errormsg);
        $("body").addClass("showOverly");
        $("#errorDrawer").fadeIn(500);
        drawerTimeout = setTimeout(function(){
          $("body").removeClass("loading showOverly"), $("#errorDrawer").fadeOut(200);
          showOverly(true);
        }, 6000);
      }
    });
  },
  getDiscount(variant_id, dsc_input) {
    const dsc_input_val  = dsc_input.val();
    const apply_discounts = checkDateRange();
    if(dsc_input_val?.length > 0 && apply_discounts) {
      const variants = dsc_input_val.split(',');
      const discount = variants[0];
      for (let variant in variants) {
        if(variant == 0) continue;
        if(variants[variant] == variant_id) return discount;
      }
    }
    return false;
  },
  /**
   * Update hidden master select of variant change
   * @param {variant} variant - Currently selected variant
   */
  _updateMasterSelect: function (variant) {
    $(this.originalSelectorId, this.$container).val(variant.id);
  }
};
$( document ).ready(function() {
  productSample.init();
  // force to load modal only for test
  if($('#modal-sample').length > 0){
    setTimeout(function(){
      // $('.link-modal-sample').click();
    }, 500);
  }
 
});
